import PropTypes from 'prop-types'

import Packages from '@/components/PDP/Packages'

import TabListSection from '../TabListSection'
const PANEL_KEY = 'packages'

const PackagesPanel = ({ eventKey }) => (
  <TabListSection
    condition={eventKey === PANEL_KEY}
    eventKey={PANEL_KEY}
  >
    <div className='asset-list'><Packages /></div>
  </TabListSection>
)

export default PackagesPanel

PackagesPanel.propTypes = {
  eventKey: PropTypes.string.isRequired
}
